import React from "react";

import TemplateIndex from "../../components/TemplateIndex";
import { ICardMenu } from "../../components/CardMenu";

const Control: React.FC = () => {
    const items: ICardMenu[] = [
        {
            path: "/regionalmanagers",
            icon: "user secret",
            text: "Gerentes Regionais",
            roles: ["Admin", "Operador"],
            show: true
        },
        {
            path: "/sectormanagers",
            icon: "user",
            text: "Gerentes de setor",
            roles: ["Admin", "Operador", "GerenteR"],
            show: true
        },
        {
            path: "/agents",
            icon: "id badge",
            text: "Representantes",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS"],
            show: true
        },
        {
            path: "/resellers",
            icon: "street view",
            text: "Revendedores",
            roles: ["Admin", "Operador", "GerenteR", "GerenteS", "Representante"],
            show: true
        },
        {
            path: "admin/notifications",
            icon: "bell",
            text: "Notificações",
            roles: ["Admin"],
            show: true
        },
        {
            path: "consults",
            icon: "search",
            text: "Consultas",
            roles: ["Admin"],
            show: true
        },
        {
            path: "/entradas",
            icon: "plus square",
            text: "Entradas",
            roles: ["Admin"],
            show: true
        },
    ];

    return <TemplateIndex title="Controle" cards={items} />;
};

export default Control;
